$(function(){
	// ページ内遷移
	var offsetY = 0;
	var time = 1000;
	$('a[href^="#"]').click(function() {
		// メニューを非表示
		$('.sp-links').css('display','none');
		$('#menuButton').removeClass('active');
		// 移動先となる要素を取得
		var target = $(this.hash);
		if (!target.length) return ;
		// 移動先となる値
		var targetY = target.offset().top+offsetY;
		// スクロールアニメーション
		$('html,body').animate({scrollTop: targetY}, time, 'swing');
		// ハッシュ書き換えとく
		window.history.pushState(null, null, this.hash);
		// デフォルトの処理はキャンセル
		return false;
	});

	$(window).on("scroll", function() {
		scrollHeight = $(document).height(); //ドキュメントの高さ 
		scrollPosition = $(window).height() + $(window).scrollTop(); //現在地 
		footHeight = $("footer").innerHeight(); //footerの高さ

		if (($(this).scrollTop() > 500) && !(scrollHeight - scrollPosition  <= footHeight)) { //500以上にスクロールされた／されている時は
			$("#topBtn").addClass("topBtn-after");
		} else { //それ以外は
			$("#topBtn").removeClass("topBtn-after");
		}
	});
});